
const config: any = {
  BACKEND_BASE_URL: process.env.REACT_APP_BACKEND_BASE_URL,
  BACKEND_TXN_BASE_URL: process.env.REACT_APP_BACKEND_TXN_BASE_URL,
  EOD_BASE_URL: process.env.REACT_APP_EOD_BASE_URL,
  REPAYMENT_BASE_URL: process.env.REACT_APP_REPAYMENT_BASE_URL,
  EOD_JOB_WAIT_TIME_IN_MINUTES: process.env.REACT_APP_EOD_JOB_WAIT_TIME_IN_MINUTES,
  EOD_PULLER_JOB_START_TIME_HOUR: process.env.REACT_APP_EOD_PULLER_JOB_START_TIME_HOUR, //use 24 hours format for setting the starting time of the job
  EOD_PULLER_JOB_START_TIME_MINUTE: process.env.REACT_APP_EOD_PULLER_JOB_START_TIME_MINUTE, //use 24 hours format for setting the starting time of the job
  GSTIN_FEATURE_FLAG: process.env.REACT_APP_GSTIN_FEATURE_FLAG,
  // BACKEND_BASE_URL:"https://503d-2405-201-2-a2f4-fcfd-c8b7-664b-86b1.in.ngrok.io", //oswald
  // BACKEND_BASE_URL:"https://edc3-103-93-193-90.in.ngrok.io", //Harish Sir
  DISABLED_MENU: process.env.REACT_APP_DISABLED_MENU || "",
  ALLOWED_TIMEZONES: process.env.REACT_APP_ALLOWED_TIMEZONES?.split(",") || [],
  ALLOWED_LOCALES: process.env.REACT_APP_ALLOWED_LOCALES?.split(",") || [],
  PAYMENT_BATCHING_STRATEGIES: JSON.parse(process.env.REACT_APP_PAYMENT_BATCHING_STRATEGIES || "[]"),
  REPAYMENT_SETTLEMENT_STRATEGIES: JSON.parse(process.env.REACT_APP_REPAYMENT_SETTLEMENT_STRATEGIES || "[]"),
  CONSTITUTION_OF_BUSINESS: JSON.parse(process.env.REACT_APP_CONSTITUTION_OF_BUSINESS || "[]"),
  INTEREST_TYPES: JSON.parse(process.env.REACT_APP_INTEREST_TYPES || "[]"),
  INTEREST_LABEL: process.env.REACT_APP_INTEREST_LABEL,
  PROJECT_VERSION: process.env.REACT_APP_VERSION || "0.0.0",
  INSTRUMENT_DUE_DATE_CALCULATION_TYPES: JSON.parse(process.env.REACT_APP_INSTRUMENT_DUE_DATE_CALCULATION_TYPES || "[]"),
  BANK_LOGO: process.env.REACT_APP_BANK_LOGO || "vayana-logo.png",
  IS_BULK_MODULE_ENABLE: process.env.REACT_APP_ENABLE_BULK_ONBOARDING === "true",
  SHOW_BANK_LOGO: process.env.REACT_APP_SHOW_BANK_LOGO === "true",
  USER_SESSION_DURATION_IN_MINS : process.env.REACT_APP_USER_SESSION_DURATION_IN_MINS || 0,
  CHARGE_TYPES: JSON.parse(process.env.REACT_APP_CHARGE_TYPES || "[]"),
  DEFAULT_GST_PERCENTAGE: process.env.REACT_APP_DEFAULT_GST_PERCENTAGE || "18",
};
export default config;
